import React from "react";
import styled from "styled-components";

const ContactUs1 = () => {
  return (
    <Section>
      <Container>
        <HeadingBox>
          <Title>Contact Us</Title>
          <SubTitle>
            Thoughtfully curated gifts for every moment.
            Reach out and let us create something unforgettable.
          </SubTitle>
        </HeadingBox>

        <ContentWrapper>
          {/* LEFT SIDE */}
          <LeftCard>
            <div className="content">
              <div className="info">
                <span>📍</span>
                <p>
                  #306, Hubtown Solaris, NS Phadke Marg,<br />
                  Near East West Flyover, Andheri (E),<br />
                  Mumbai, India
                </p>
              </div>

              <div className="info">
                <span>✉️</span>
                <p>gifttoinspire@gmail.com</p>
              </div>

              <div className="info">
                <span>📞</span>
                <p>+91 22 61164444</p>
              </div>

              <div className="info">
                <span>📱</span>
                <p>+91 9820700011</p>
              </div>

              <div className="info">
                <span>💬</span>
                <p>+91 9820700011</p>
              </div>
            </div>
          </LeftCard>

          {/* RIGHT SIDE */}
          <RightMap>
            <iframe
              title="office-map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d30272.870650568765!2d72.844391!3d19.118719!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c82f3ee1e3b1%3A0xf8a84dea89fa1c00!2sAndheri%20East%2C%20Mumbai!5e0!3m2!1sen!2sin!4v1700000000000"
              loading="lazy"
            ></iframe>
          </RightMap>
        </ContentWrapper>
      </Container>
    </Section>
  );
};

export default ContactUs1;

/* ---------------- FIXED STYLED COMPONENTS ---------------- */

const Section = styled.div`
  width: 100%;
  background: #f5f1ea;
  padding: 60px 0;
`;

const Container = styled.div`
  width: 100%;
  max-width: 1400px;   /* ✅ LOCKED WIDTH */
  margin: auto;
//   padding: 0 20px;
`;

const HeadingBox = styled.div`
  text-align: left;
  margin-bottom: 50px;
`;

const Title = styled.h2`
  font-size: 38px;    /* ✅ PX instead of rem */
  font-weight: 700;
  color: #1c1c1c;
  position: relative;
  width: fit-content;

  &:after {
    content: "";
    position: absolute;
    bottom: -10px;
    left: 0;
    width: 60px;
    height: 4px;
    background: #d2a65c;
    border-radius: 4px;
  }
`;

const SubTitle = styled.h3`
  margin-top: 25px;
  color: #555;
  font-weight: 400;
  font-size: 18px;   /* ✅ PX instead of rem */
  max-width: 680px;
`;

const ContentWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1.3fr; /* ✅ HARD STABILIZED */
  gap: 40px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

const LeftCard = styled.div`
  background: #0f0f0f;
  color: #fff;
  border-radius: 16px;
  padding: 46px 38px;
  box-shadow: 0 20px 40px rgba(0,0,0,0.25);
  border-top: 12px solid #d2a65c;

  .content {
    display: flex;
    flex-direction: column;
    gap: 28px;
  }

  .info {
    display: flex;
    gap: 16px;
    align-items: flex-start;

    span {
      font-size: 26px;   /* ✅ PX */
    }

    p {
      margin: 0;
      font-size: 18px;  /* ✅ PX */
      line-height: 1.6;
      color: #e8e8e8;
    }
  }
`;

const RightMap = styled.div`
  width: 100%;
  max-width: 650px;   /* ✅ CRITICAL FIX */
  border-radius: 16px;
  overflow: hidden;
  height: 520px;     /* ✅ LOCKED HEIGHT */
  box-shadow: 0 20px 40px rgba(0,0,0,0.18);
  margin-left: auto;

  iframe {
    width: 100%;
    height: 100%;
    border: none;
  }

  @media (max-width: 900px) {
    max-width: 100%;
    height: 400px;
  }
`;
